import React from 'react'
import ReactDOM from 'react-dom/client'
import { 
  ApolloClient, 
  InMemoryCache, 
  createHttpLink, 
  ApolloProvider
} from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import App from './App'
import './index.css';
import { BrowserRouter } from 'react-router-dom'

const httpLink = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_URI || '/api/graphql',
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ApolloProvider client={client}>
        <App />
      </ApolloProvider>
    </BrowserRouter>
  </React.StrictMode>,
)